import { useCallback, useMemo } from "react";

import { useFilter } from "~/providers/FilterProvider";

export const useCategoryFilterDropdown = () => {
  const { filters, updateFilters } = useFilter();

  const selectedValue = useMemo(
    () => filters.categoryId ?? null,
    [filters.categoryId]
  );

  const onChangeCategoryFilter = useCallback(
    (value?: string) => {
      updateFilters({ categoryId: value });
    },
    [updateFilters]
  );

  return { selectedValue, onChangeCategoryFilter };
};
